import { render, staticRenderFns } from "./CustomLists.vue?vue&type=template&id=629364bc&"
import script from "./CustomLists.vue?vue&type=script&lang=js&"
export * from "./CustomLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports